<template>
  <div>
    <WizzardStepper
      :questionOrder="wizardOrder"
      :categoryTree="categoryTree"
      @finish="handleWizzardFinish"
    />
  </div>
</template>

<script>
import CategoryItem from "@/components/WizzardPage/CategoryItem";
import Question from "../components/WizzardPage/Question.vue";
import WizzardStepper from "@/components/WizzardPage/WizzardStepper";

export default {
  name: "WizardPage",
  components: {
    CategoryItem,
    Question,
    WizzardStepper,
  },
  methods: {
    handleWizzardFinish(e) {
      this.$router.push({
        name: "products",
        query: {
          filters: JSON.stringify({
            categories: e,
          }),
        },
      });
    },
  },
  computed: {
    categoryTree() {
      const categoryTree = this.$store.getters["categories/categoryTree"];
      return categoryTree.filter((cat) => cat.slug !== "uncategorized");
    },
    wizardOrder() {
      return this.shopSettings.wizardCategories
        .split(",")
        .map((catIndex) => +catIndex);
    },
  },
};
</script>

<style scoped></style>
